<template><v-dialog light v-if="shown" content-class="simple-dialog" :fullscreen="fullscreen" eager v-model="shown" :max-width="max_width" scrollable persistent overlay-opacity="0.9" @keydown.esc="cancel">
	<v-card role="dialog" aria-model="true" tabindex="-1" :ripple="false" style="cursor: auto;" :aria-labelledby="message.title">
		<v-card-title v-if="message.title">
			<h3 :id="message.title" v-html="message.title"></h3>
		</v-card-title>
		<v-card-text >
			<div v-html="message.text"></div>
			<v-text-field ref="textInput" dense outlined hide-details class="simple-dialog-text-field" v-if="type === 'prompt' && message.promptType === 'text'" :type="(message.password&&!show_password) ? 'password' : 'text'" autocomplete="new-password" v-model="text_input" @keyup="checkSubmit" @focus="enable_keyup">
				<template slot="append">
					<v-icon @click="toggle_password" :aria-label="show_password ? 'Password is currently shown. Click to hide password' : 'Password is currently hidden. Click to show password'">
					{{ show_password ? 'fas fa-eye' : 'fas fa-eye-slash' }}
					</v-icon>
				</template>
			</v-text-field>
			<v-textarea ref="textareaInput" dense outlined hide-details auto-grow class="simple-dialog-textarea" v-if="type === 'prompt' && message.promptType === 'textarea'" v-model="text_input"></v-textarea>
			<v-file-input ref="fileInput" dense outlined hide-details placeholder="Select a file…" class="simple-dialog-file-input" v-if="type === 'prompt' && message.promptType === 'file'" v-model="file_input"></v-file-input>
			<v-autocomplete ref="autocompleteInput" dense outlined hide-details auto-grow class="simple-dialog-autocomplete" v-if="type === 'prompt' && message.promptType === 'autocomplete'" v-model="text_input" :items="autocomplete_items" :loading="autocomplete_loading" :search-input.sync="autocomplete_search" hide-no-data hide-selected></v-autocomplete>
			<v-select ref="selectInput" dense outlined hide-details class="simple-dialog-select-input" v-if="type === 'prompt' && message.promptType === 'select'" v-model="text_input" :items="message.selectOptions" label=""></v-select>

			<div v-if="message.secondaryCheckbox" class="mt-3">
				<v-checkbox class="mt-0 pt-0" v-model="checkbox_value" hide-details><template v-slot:label><div style="color:#000" v-html="message.secondaryCheckbox"></div></template></v-checkbox>
			</div>
		</v-card-text>
		<v-card-actions>
			<v-btn v-on:click="cancel" class="simple-dialog-dismiss-btn" dark :color="message.cancelColor" v-if="type !== 'alert'" :style="message.hideCancel==true?'visibility:hidden;height:0px;':''">
				<v-icon v-if="message.cancelIcon" small class="mr-2">{{message.cancelIcon}}</v-icon>
				<span v-html="message.cancelText"></span>
				<v-icon v-if="message.cancelIconAfter" small class="ml-2">{{message.cancelIconAfter}}</v-icon>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn v-if="message.extraBtnText" v-on:click="extra_btn_clicked" dark :color="message.extraBtnColor" ref="extraBtn" class="mr-2">
				<v-icon v-if="message.extraBtnIcon" small class="mr-2">{{message.extraBtnIcon}}</v-icon>
				<span v-html="message.extraBtnText"></span>
				<v-icon v-if="message.extraBtnIconAfter" small class="ml-2">{{message.extraBtnIconAfter}}</v-icon>
			</v-btn>

			<v-btn v-on:click="accept" :class="type=='alert'?'simple-dialog-dismiss-btn':''" dark :color="message.acceptColor" :style="message.hideAccept==true?'visibility:hidden;height:0px;':''" :disabled="accept_disabled" ref="acceptBtn">
				<v-icon v-if="message.acceptIcon" small class="mr-2">{{message.acceptIcon}}</v-icon>
				<span v-html="message.acceptText"></span>
				<v-icon v-if="message.acceptIconAfter" small class="ml-2">{{message.acceptIconAfter}}</v-icon>
			</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog></template>

<script>
	export default {
		name : "SimpleDialog",
		props : {
			type : String,
			message : Object,
			resolve : Function
		},
		data() { return {
			shown: false,
			text_input: '',
			file_input: [],
			autocomplete_loading: false,
			autocomplete_search: '',
			autocomplete_items: [],
			checkbox_value: false,
			show_password: false,
			keyup_enabled: false
		}},
		created() {
			if (this.message.initialValue != null) {
				this.text_input = this.message.initialValue;
			}
			if (this.message.secondaryCheckboxInitiallyOn) this.checkbox_value = true
		},
		computed: {
			fullscreen() { return this.message.fullscreen === true },
			max_width() {
				if (this.$vuetify.breakpoint.xs) return '100vw'
				return this.message.dialogMaxWidth || 500
			},
			accept_disabled() {
				if (this.message.disableForEmptyValue) {
					return (this.text_input == '' && this.file_input.length == 0)
				}
				return false
			},
		},
		watch: {
			autocomplete_search(val) {
				/*
					To use autocomplete, either specify `autocompleteItems` in the $prompt call (they should be an array of strings),
					or specify a `serviceName` value, in which case:
						- this fn will call serviceName to retrieve the items based on the first 3 characters the user types
						- the service must return an array of `entries` in the result
						- caller can optionally specify `entryField` to use a field of the returned objects;
						  if entryField isn't specified, the service will receive `return_string:yes`, which should signal it to return an array of strings
				*/

				if (this.message.autocompleteItems) {
					// if requiredAutocompleteCharacters parameter is included, require the user to type at least that many characters before the list appears
					if (this.message.requiredAutocompleteCharacters && (!val || val.length < this.message.requiredAutocompleteCharacters)) this.autocomplete_items = []
					else this.autocomplete_items = this.message.autocompleteItems
					return
				}

				if (!this.message.serviceName) return

				// items have already been requested
				if (this.autocomplete_loading) return

				// don't search until we have three characters; then if the value drops back below three characters, clear autocomplete_items so we'll search again when we get back to 3
				if (!val || val.length < 3) {
					this.autocomplete_items = []
					return
				} else if (this.autocomplete_items.length > 0 && val.length > 3) {
					// if we don't have any items, the search service may have overloaded, so keep trying if the user keeps typing
					return
				}

				// if we get to here, search for items
				this.autocomplete_loading = true
				let payload = {
					user_id: vapp.user_info.user_id,
					// if an entryField is specified, we want the service to return an object; otherwise tell it to return a string
					return_string: (this.message.entryField) ? 'no' : 'yes',
					stem: val,
				}
				U.ajax(this.message.serviceName, payload, result=>{
					// parse results, which should be in result.entries
					let arr = []
					for (let entry of result.entries) {
						// if entryField is specified, entries should be objects; get the right field
						if (this.message.entryField) arr.push(entry[this.message.entryField])
						// else entries should be strings
						arr.push(entry)
					}
					this.autocomplete_items = arr
					this.autocomplete_loading = false
				})
			},
		},
		methods : {
			// Note: if caller asked for the checkbox, send an array with the checkbox_value the second item in the array, if the user clicked the accept or extra btn
			cancel() {
				if (this.message.rejectCloseOnClick) this.shown = false;
				// if they click the cancel btn, we have to return false for the resolve fn to work properly (this could be updated if we really need to)
				this.resolve(false);
			},
			accept() {
				if (this.message.resolveCloseOnClick) this.shown = false;
				if (this.type == 'prompt') {
					// note that although file_input is defined as an array, since we only currently allow for one file to be selected, only a single file object is returned.
					if (this.message.promptType == 'file') {
						let rv = (this.message.secondaryCheckbox) ? [this.file_input, this.checkbox_value] : this.file_input
						this.resolve(rv)
						return
					}

					// if type is 'autocomplete' and we didn't get a text_input, return the autocomplete_search value
					if (!this.text_input) this.text_input = this.autocomplete_search

					let rv = (this.message.secondaryCheckbox) ? [this.text_input, this.checkbox_value] : this.text_input
					this.resolve(rv)

				} else {
					let rv = (this.message.secondaryCheckbox) ? [true, this.checkbox_value] : true
					this.resolve(rv)
				}
			},
			extra_btn_clicked() {
				// extra btn option -- allows for a choice of two things with an additional cancel option -- only used with 'confirm'
				if (this.message.resolveCloseOnClick) this.shown = false;
				let rv = (this.message.secondaryCheckbox) ? ['extra', this.checkbox_value] : 'extra'
				this.resolve(rv);
				// caller should look for `x === 'extra'` as the return value
			},
			checkSubmit(evt) {
				if (!this.keyup_enabled) return
				if (evt.key === "Enter") {
					this.accept();
				}

				// if allCaps is true, transform input to upper case
				if (this.message.allCaps) {
					this.text_input = this.text_input.toUpperCase()
				}
			},
			toggle_password() {
				this.show_password = !this.show_password
				this.keyup_enabled = false
			},
			enable_keyup() {
				setTimeout(x=>{
					// enable the keyup event for the inputs after a second; if it's enabled at the start, then if the user opened the sign-in dialog by hitting the return key, the keyup event sometimes fires right away
					this.keyup_enabled = true
				}, 1000)
			}
		},
		mounted() {
			this.shown = true;
			if (this.type === "prompt"){
				setTimeout(function() {
					if (this.message.promptType == 'text') {
						$(this.$refs.textInput.$el).find('input').focus()
						$(this.$refs.textInput.$el).find('input').select()
					} else if (this.message.promptType == 'textarea') {
						$(this.$refs.textareaInput.$el).find('textarea').focus()
						$(this.$refs.textareaInput.$el).find('textarea').select()
					}
				}.bind(this), 300 );
			}

			if (this.message.focusBtn) {
				setTimeout(function() {
					$(this.$refs.acceptBtn.$el).focus()
				}.bind(this), 300 );
			}
		}
	}
</script>

<style>
.simple-dialog .v-card {
	background-color:#f8f8f8!important;
}

.simple-dialog-textarea textarea {
	margin-top:0!important;
}

.simple-dialog-text-field {
	margin-top:8px!important;
}

.simple-dialog-file-input {
	margin-top:15px!important;
}

.simple-dialog-autocomplete {
	margin-top:8px!important;
}

.simple-dialog .v-card__text {
	font-size:16px;
	line-height:24px;
	color:#111!important;
	padding:12px!important;
	/* border-color:#ddd;
	border-style:solid;
	border-width:8px 4px; */
}

.simple-dialog .v-card__actions {
	/* background-color:#ddd; */
	padding:8px 8px 8px 8px;
}

.simple-dialog .v-card__title {
	/* background-color:#ddd; */
	padding:8px 12px 0 12px!important;
	word-break: normal;
}
.simple-dialog .v-card__title h3 {
	font-size:24px;
	margin:0;
	padding:0;
	color:#111!important;
}

.simple-dialog .v-input--checkbox .v-input__slot {
	align-items:flex-start;
}

@media (max-width: 600px) {
	.simple-dialog {
		border-radius:0!important;
		min-height:20vh;
		max-height:100vh!important;
		margin: 0 4px;
	}

	.simple-dialog .v-card {
		/* border-radius:0!important; */
		/* height:100vh; */
	}

	.simple-dialog .v-card__text {
		font-size:15px;
		line-height:22px;
		padding:8px!important;
	}

	.simple-dialog .v-card__title {
		padding:8px 8px 0 8px!important;
	}
	.simple-dialog .v-card__title h3 {
		font-size:20px;
		text-align:center;
	}

	.simple-dialog .v-card__actions {
		flex-wrap:wrap;
	}

	.simple-dialog .v-card__actions .v-btn {
		width:100%;
		margin-top:5px;
	}
}
</style>
